var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.languageOptions,"reduce":label => label.code,"label":"label"},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }